import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import AppointmentModalStore from './store';
import TinyInput from '@src/components/tiny-input';
import SmsCodeInput from '@src/components/sms-code-input';

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const AppointmentModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  const agreement = 'https://j.xoyo.com/show-7721-24-1.html';
  //  手机号预约预约
  const renderAppointment = () => {
    return (
      <React.Fragment>
        <div className={cx(styles.platform)}>
          {store.list.map((item, index) => {
            return (
              <Link
                key={index}
                className={cx(styles.platformItem, store.platform === item.value && styles.platform_active)}
                onClick={() => {
                  store.clickPlatform(item);
                }}
              >
                {item.label}
              </Link>
            );
          })}
        </div>
        <div className={styles.platformText}>
          选择您的设备，点击“预约”代表您同意我们像您的<br />手机号发送短信通知或以手机号参与活动。
        </div>

        <div className={styles.contentInput} data-name="手机号">
          <div className={styles.inputBox}>
            <TinyInput className={styles.input} store={store.phoneInputStore} placeholder="请输入手机号" maxLength={20} />
          </div>
        </div>
        <div className={cx(styles.contentInput, styles.contentInput2)} data-name="验证码">
          <div className={cx(styles.inputBox, styles.inputBox2)}>
            <TinyInput className={styles.input} store={store.smsInputStore} placeholder="请输入验证码" maxLength={20} />
          </div>
          <div className={styles.codeBox}>
            <SmsCodeInput
              codeBtnClassName={styles.codeBtn}
              agreement={store.agreementType}
              phone={store.phoneInputStore.value}
              buttonText={'获取验证码'}
              sendCode={store.onSendVCRequest}
            />
          </div>
        </div>
        <div
          className={cx(styles.agreement, store.agreementType && styles.checked)}
          onClick={() => {
            store.clickAgreement();
          }}
        >
          已阅读并同意
          <Link onClick={store.clickStopPropagation} target="_blank" href={'https://jxqy.seasungames.cn/miniprogram-user-privacy-policy'}>
            《金山在线隐私权政策》
          </Link>
          <Link onClick={store.clickStopPropagation} target="_blank" href={'https://www.seasungames.cn/p/zt/2024/06/20/index/#/terms-of-service'}>
            《金山网络服务使用协议》
          </Link>
        </div>

        <Link
          className={cx(styles.appointmentBtn)}
          data-name="预约按钮"
          onClick={() => {
            store.onAppointmentClick();
          }}
        />
        <Link
          className={cx(styles.switch, styles.enterSwitch)}
          data-name="切换预约方式"
          onClick={() => {
            store.onswitchingAppointmentMethod();
            // $$tracker.clickPhoneOrder();
          }}
        >
          扫码预约
        </Link>
      </React.Fragment>
    );
  };
  // 微信扫码预约
  const renderAppointmentCode = () => {
    return (
      <React.Fragment>
        <div className={styles.qrcodeImgBox}>{store.qrcodeImg ? <img src={store.qrcodeImg} className={styles.qrcodeImg} alt="" /> : '加载中...'}</div>
        {/* <img src={store.qrcodeImg} className={styles.qrcodeImg} alt="" /> */}
        <Link
          className={cx(styles.switch)}
          data-name="切换预约方式"
          onClick={() => {
            store.onswitchingAppointmentMethod();
            // $$tracker.clickPhoneOrder();
          }}
        >
          手机号预约
        </Link>
      </React.Fragment>
    );
  };
  // 预约/登录成功
  const renderAppointmentSuccess = () => {
    return (
      <React.Fragment>
        <div className={styles.textSuccess} />
        <img className={styles.prize} src={require('./images/prize1.png')} alt="" />
        <div className={styles.subtitle} />
        <img className={styles.prize} src={require('./images/prize2.png')} alt="" />
        <div className={styles.qrCodeBox}>
          <div className={styles.qrBg}>
            <img src={require('./images/qr_code.jpg')} alt="二维码" />
          </div>
        </div>
      </React.Fragment>
    );
  };

  const appointment = () => {
    if (store.modalType === 1) {
      console.log('store.AppointmentMethod', store.AppointmentMethod);
      if (store.AppointmentMethod) {
        return renderAppointmentCode();
      } else {
        return renderAppointment();
      }
    } else if (store.modalType === 2) {
      return renderAppointmentSuccess();
    }
  };

  return (
    <ModalContainer modalState={store.isOpen}>
      <div
        className={cx(
          styles.bg,
          store.modalType === 1 && store.AppointmentMethod && styles.sendCodeBg,
          store.modalType === 1 && !store.AppointmentMethod && styles.enterBg,
          store.modalType === 2 && styles.appointmentSuccessfulBg
        )}
      >
        <Link
          className={styles.closeBtn}
          onClick={() => {
            store.onClickClose();
            // onClose();
          }}
        />
        <div className={styles.content}>{appointment()}</div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(AppointmentModal, AppointmentModalStore);
